import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import AdminMenuComponent from './admin-menu.component';

let AdminMenuModule = angular
  .module('AdminMenu', [
    uiRouter
  ])
  .component('adminmenu', AdminMenuComponent)
  .name;

export default AdminMenuModule;



// WEBPACK FOOTER //
// ./src/app/components/admin-menu/admin-menu.module.js